exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-be20dede","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":"/home/yan3/jenkins-agent/workspace/MARKING_VUE_REGION_FRONTEND_BUILD/src/assets/styles/variable.scss"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/datav/layout.vue
// module id = cNHo
// module chunks = 129